module.exports = __webpack_public_path__ + "img/gf.a73b51b1.svg";